
import { actionTypes } from "./actionTypes";
import axios from "axios";
import api from '../../utilities/api';
import { getMessage } from '../../utilities/getMessage';

export const getLoseMessages = (token) => async dispatch => {
      start();
      const options = {
            url: `${api}/loseMessages`,
            method: 'GET',
            headers: {
                  Authorization: `Bearer ${token}`
            },
      }
      await axios(options)
            .then(response => success(response.data))
            .catch(error => fail(error))

      function start() {
            dispatch({
                  type: actionTypes.GET_LOSE_MESSAGES_START
            })
      }
      function success(data) {
            dispatch({
                  type: actionTypes.GET_LOSE_MESSAGES_SUCCESS,
                  payload: data
            })
      }
      function fail(err) {
            dispatch({
                  type: actionTypes.GET_LOSE_MESSAGES_FAIL,
                  payload: getMessage(err)
            })
      }
}